module.exports = __webpack_public_path__ + "static/media/icon_q.f0c091b8.svg";